import React, { useState, useEffect,} from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';


const AddNotes = props => {
    const {visible, note, handleCancel, handleSaveNote, handleToggle} = props;
    const [defaultNote, setNote] = useState("");
    const [editMode, setEditMode] = useState(false);
    useEffect(() => {
        if(visible){
            setNote(note || "");
            setEditMode(note ? true : false);
        }
    }, [visible]);

    const handleNoteFieldChange = e => {
        setNote(e.target.value);
    };
    const validateNote = () => {
        if (defaultNote && defaultNote.trim()) {
            return ({isValid: true, note: defaultNote.trim()});
        }
        else{
            return ({isValid: false, note: defaultNote});
        }
        
      };
    
    return(
        <Modal
        style={{maxWidth: '650px'}}
        isOpen={visible}
        toggle={handleToggle}
        >
            <ModalHeader>
                {!editMode ? 'New' : 'Edit'} Note
            </ModalHeader>
            <ModalBody>
            <textarea
                rows="6" cols="20"
                type="text"
                className="form-control"
                placeholder={"Note"}
                value={defaultNote == null ? '' : defaultNote}
                onChange={handleNoteFieldChange}
                name={name}
            />
            </ModalBody>
            <ModalFooter>
                <Button color={'primary'} onClick={() => handleSaveNote({ note: defaultNote && defaultNote.trim()})} disabled={!validateNote().isValid}>Save</Button> 
                <Button color={'secondary'} onClick={handleCancel}>Close</Button>
            </ModalFooter>
        </Modal>
    );
};

AddNotes.propTypes = {
    note: PropTypes.string,
    handleCancel: PropTypes.func,
    handleSaveNote: PropTypes.func,
    visible: PropTypes.bool,
  };
  
  AddNotes.defatultProps = {
    note: "",
    visible: false,
  };
export default AddNotes;